import { QueryHookOptions } from '@apollo/client'
import { PageAccountParams } from 'Routes'
import {
  AccountDetailsQuery,
  AccountDetailsQueryVariables,
  PtdSettings,
  useAccountDetailsQuery
} from 'generated/graphql'
import { useParams } from 'react-router-dom'
import formatAddress from 'utils/formatAddress'

const useAccount = (
  options?: QueryHookOptions<AccountDetailsQuery, AccountDetailsQueryVariables>
) => {
  const { accountUrl = '' } = useParams<PageAccountParams>()

  const result = useAccountDetailsQuery({
    variables: { accountUrl },
    ...options
  })

  const accountId = result.data?.accountDetail?.id ?? ''
  const accountName = result.data?.accountDetail?.name ?? ''
  const city = result?.data?.accountDetail?.city ?? ''
  const state = result?.data?.accountDetail?.state ?? ''
  const latitude = result?.data?.accountDetail?.latitude ?? ''
  const longitude = result?.data?.accountDetail?.longitude ?? ''
  const accountAddress = formatAddress({ city, state })
  const ptdSettings =
    result.data?.accountDetail?.ptdSettings ?? ({} as Partial<PtdSettings>)
  const logo = ptdSettings.logo ?? ''
  const title = ptdSettings.title ?? ''
  const description = ptdSettings.description ?? ''
  const sampleExplanation = ptdSettings.sampleExplanation ?? ''
  const hideServiceLines = ptdSettings.hideServiceLines ?? false
  const consumerConfidenceReportURL =
    ptdSettings.consumerConfidenceReportURL ?? ''
  const contactLinkURL = ptdSettings.contactLinkURL ?? ''

  return {
    ...result,
    accountAddress,
    accountId,
    accountName,
    accountUrl,
    description,
    hideServiceLines,
    logo,
    ptdSettings,
    sampleExplanation,
    title,
    latitude,
    longitude,
    consumerConfidenceReportURL,
    contactLinkURL
  }
}

export default useAccount
